import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ModuleHead extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.moduleHead}>
                <div className={styles.title}>{content.zhText}</div>
                {content.enText && <div className={styles.subTitle}>{content.enText}</div>}
                {content.moreUrl && (
                    <a href={content.moreUrl} target="_blank" className={styles.more}>
                        更多
                    </a>
                )}
            </div>
        );
    }
}

export default errorBoundary(ModuleHead);
